// Internal links (article links) take on the following structure /category/article-slug
// e.g. "/entertainment/pijnlijke-confrontatie-voor-roxeanne-met-rachel"
// Therefore, if the link has a regular structure (starting with https protocol), it is an external one
export const getLinkProps = (uri: string) =>
  uri.startsWith("https") ? { rel: "noopener noreferrer", target: "_blank" } : {};
